import { pageFactory } from '../support';

export const SharePanelModal = pageFactory({
  url: '',
  selectors: {
    linkToRenderedImage: 'Link to rendered image',
  },
});
